'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterStoreSwitcher = function () {
  function FooterStoreSwitcher(el) {
    (0, _classCallCheck3.default)(this, FooterStoreSwitcher);

    var context = { context: el };

    this.els = {
      el: el,
      flag: (0, _functional.getElement)('[data-el="footer-store-switcher.flag"]', context),
      select: (0, _functional.getElement)('[data-el="footer-store-switcher.select"]', context),
      options: (0, _functional.getElements)('[data-el="footer-store-switcher.option"]', context)
    };

    this.setupListeners();
  }

  (0, _createClass3.default)(FooterStoreSwitcher, [{
    key: 'setupListeners',
    value: function setupListeners() {
      this.onSelectChange = this.onSelectChange.bind(this);
      this.els.select.addEventListener('change', this.onSelectChange);
    }
  }, {
    key: 'onSelectChange',
    value: function onSelectChange(event) {
      var eventTarget = event.target;
      var selectedOption = eventTarget.options[eventTarget.selectedIndex];

      // Data attributes
      var _selectedOption$datas = selectedOption.dataset,
          url = _selectedOption$datas.url,
          store = _selectedOption$datas.store,
          flagImageSrc = _selectedOption$datas.flagImageSrc;


      this.updateFlag(flagImageSrc);
      this.updateCookie(store);

      var updatedUrl = this.updateUrlPath(url);

      /* eslint-disable no-console */
      console.log('Directing user to:', updatedUrl);
      /* eslint-enable no-console */

      window.location.href = updatedUrl;
    }
  }, {
    key: 'updateUrlPath',
    value: function updateUrlPath(url) {
      var _ref = new URL(window.location.href),
          currentHostname = _ref.hostname,
          currentPathname = _ref.pathname;

      if (currentPathname === '/') {
        return url;
      }

      var urlObject = new URL(url);

      // Check whether URL is within the same domain
      if (urlObject.hostname === currentHostname && urlObject.pathname === '/') {
        // If it is, and there's no path that already exists, we update the URL to use the current path
        urlObject.pathname = currentPathname;

        url = urlObject.href;

        var pathnameSplit = currentPathname.split('/');
        if (!this.shopifyPathnames.includes(pathnameSplit[1])) {
          url = url.replace('/' + pathnameSplit[1], '');
        }
      }

      return url;
    }
  }, {
    key: 'updateFlag',
    value: function updateFlag() {
      var imageSrc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.els.flag.src = imageSrc || '';
      this.els.flag.style.opacity = imageSrc ? 1 : 0;
    }
  }, {
    key: 'updateCookie',
    value: function updateCookie(store) {
      _jsCookie2.default.set(this.cookieName, store, { expires: 90 });
    }
  }, {
    key: 'shopifyPathnames',
    get: function get() {
      return ['pages', 'products', 'collections', 'blogs', 'policies', 'search', 'account', 'cart', '404'];
    }
  }, {
    key: 'cookieName',
    get: function get() {
      return 'BAO-selected-store';
    }
  }]);
  return FooterStoreSwitcher;
}();

exports.default = FooterStoreSwitcher;